import { i18n } from 'core/i18n';
import React from 'react';
import { OKButton } from 'components/commons/OKButton/OKButton';
import DocumentsModalFooterPrimaryButton from './DocumentsModalFooterPrimaryButton';

const { formatText } = i18n

export const DocumentsModalFooter = ({
    areAlldocumentsAccepted,
    isCurrentDocumentAcepted,
    isCurrentDocumentRead,
    isSavingDocumentAcceptance,
    onClose,
    onCancel,
    onConfirm,
    onContinue,
    onAcceptAndContinue,
    onContinueDisabled,
}) => {

    return (
        <div className="documents__modal-buttons">
            <span>
                {isCurrentDocumentAcepted ? (
                    <OKButton onClick={onClose} modifier="link-ghost">
                        <p>{formatText('contractsView-dic_buttonClose')}</p>
                    </OKButton>
                ) : (
                    <OKButton onClick={onCancel} modifier="link-ghost">
                        <p>{formatText('contractsView-dic_buttonGoBack')}</p>
                    </OKButton>
                )}
            </span>
            <DocumentsModalFooterPrimaryButton 
                isCurrentDocumentRead={isCurrentDocumentRead} 
                areAlldocumentsAccepted={areAlldocumentsAccepted}
                isCurrentDocumentAcepted={isCurrentDocumentAcepted}
                isSavingDocumentAcceptance={isSavingDocumentAcceptance}
                onConfirm={onConfirm}
                onContinue={onContinue}
                onAcceptAndContinue={onAcceptAndContinue}
                onContinueDisabled={onContinueDisabled}
            />
        </div>
    );
};
